module.exports = __webpack_public_path__ + "media/images/home_two-074e0db25e04305d0fbcf1e071c8e890.jpg";